// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Стилі для кнопки "Запитати допомогу" */
.ask-help-btn {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border: none;
  background-color: #e2e8f0;
  color: #4a5568;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ask-help-btn:hover {
  background-color: #cbd5e0;
  transform: scale(1.05);
}

.ask-help-btn.marked {
  background-color: #ed8936;
  color: white;
}

.ask-help-btn.marked:hover {
  background-color: #dd6b20;
  transform: scale(1.05);
}

.task-card.in-progress .ask-help-btn {
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
}

.task-card.in-progress .ask-help-btn:hover {
  background-color: rgba(255, 255, 255, 0.3);
}

.task-card.in-progress .ask-help-btn.marked {
  background-color: #ed8936;
  color: white;
}

/* Стилі для пулу задач з запитом про допомогу */
.ask-help-pool {
  border-left: 3px solid #ed8936;
}

.tasks-page.dark-theme .ask-help-pool {
  border-left-color: #dd6b20;
}

/* Приховування кнопок на маленьких екранах (менше 590px) */
@media (max-width: 590px) {
  .ask-help-btn {
    display: none !important;
  }
  
  .no-help-btn {
    display: none !important;
  }
  
  .reverse-timer-btn {
    display: none !important;
  }
}

/* Для екранів від 391px до 590px - приховуємо тільки деякі кнопки */
@media (min-width: 391px) and (max-width: 590px) {
  .ask-help-btn {
    width: 28px;
    height: 28px;
    font-size: 14px;
  }
  
  .no-help-btn {
    width: 28px;
    height: 28px;
    font-size: 14px;
  }
  
  .reverse-timer-btn {
    width: 28px;
    height: 28px;
    font-size: 14px;
  }
}

/* Для екранів менше 390px - всі додаткові кнопки приховані */
@media (max-width: 390px) {
  .ask-help-btn {
    display: none !important;
  }
  
  .no-help-btn {
    display: none !important;
  }
  
  .reverse-timer-btn {
    display: none !important;
  }
  
  .task-link-btn {
    display: none !important;
  }
  
  .task-timer {
    font-size: 8px;
    padding: 2px 4px;
    height: 20px;
  }
  
  .task-expired-time {
    font-size: 8px;
    padding: 2px 4px;
    height: 20px;
  }
  
  .task-startdate {
    font-size: 8px;
    padding: 2px 4px;
    height: 20px;
  }
  
  .task-name {
    font-size: 10px;
  }
}

/* Стилі для кнопки PiP Mode - приховуємо на екранах менше 790px */
@media (max-width: 790px) {
  .pip-toggle-btn {
    display: none !important;
  }
}

/* Адаптація для дуже маленьких екранів (менше 320px) */
@media (max-width: 320px) {
  .task-content {
    padding: 4px;
    gap: 4px;
  }
  
  .task-name {
    font-size: 9px;
  }
  
  .task-timer,
  .task-expired-time,
  .task-startdate {
    font-size: 7px;
    padding: 1px 3px;
    height: 18px;
  }
  
  .pool-title-m {
    font-size: 9px;
  }
  
  .task-count-m {
    font-size: 8px;
  }
  
  .collapse-btn {
    width: 24px;
    height: 24px;
    font-size: 12px;
  }
}

/* Додаткові стилі для кращого відображення на планшетах */
@media (min-width: 591px) and (max-width: 790px) {
  .ask-help-btn {
    width: 30px;
    height: 30px;
    font-size: 15px;
  }
  
  .no-help-btn {
    width: 30px;
    height: 30px;
    font-size: 15px;
  }
  
  .reverse-timer-btn {
    width: 30px;
    height: 30px;
    font-size: 15px;
  }
  
  .task-timer,
  .task-expired-time,
  .task-startdate {
    font-size: 11px;
    padding: 3px 6px;
    height: 28px;
  }
  
  .task-name {
    font-size: 12px;
  }
}

/* Стилі для темної теми кнопок */
.tasks-page.dark-theme .ask-help-btn {
  background-color: #4a5568;
  color: #e2e8f0;
}

.tasks-page.dark-theme .ask-help-btn:hover {
  background-color: #718096;
}

.tasks-page.dark-theme .ask-help-btn.marked {
  background-color: #dd6b20;
  color: white;
}

.tasks-page.dark-theme .no-help-btn {
  background-color: #4a5568;
  color: #e2e8f0;
}

.tasks-page.dark-theme .no-help-btn.active {
  background-color: #48bb78;
  color: white;
}

.tasks-page.dark-theme .no-help-btn.marked {
  background-color: #48bb78;
  color: white;
}

.tasks-page.dark-theme .reverse-timer-btn {
  color: #e2e8f0;
}

.tasks-page.dark-theme .reverse-timer-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.tasks-page {
    padding: 20px;
    background-color: #f5f5f5;
    min-height: 100vh;
   
  }
  
  @media (max-width: 390px) {
    .tasks-page {
      padding: 10px;
    }
  }
  
  .pool-section {
    
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 0px;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }
  
  @media (max-width: 390px) {
    .pool-section {
      padding: 12px;
      margin-bottom: 0px;
    }
  }
  
  .pool-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
  }
  
  @media (max-width: 390px) {
    .pool-header {
      margin-bottom: 6px;
    }
  }

  .pool-header-left {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .pool-title-m {
    font-size: 18px;
    font-weight: 600;
    color: #2d3748;
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0;
  }
  
  @media (max-width: 1000px) {
    .pool-title-m {
      font-size: 15px;
      font-weight: 20;
    }
  }
  
  @media (max-width: 390px) {
    .pool-title-m {
      font-size: 10px;
    }
  }
  
  .task-count-m {
    font-size: 18px;
    color: #718096;
    font-weight: 500;
  }
  
  @media (max-width: 390px) {
    .task-count-m {
      font-size: 9px;
    }
  }
  
  .collapse-btn {
    background-color: #4299e1;
    color: white;
    border: none;
    border-radius: 6px;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.2s;
  }
  
  @media (max-width: 390px) {
    .collapse-btn {
      width: 28px;
      height: 28px;
      font-size: 14px;
    }
  }
  
  .collapse-btn:hover {
    background-color: #3182ce;
  }
  
  .tasks-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  
  @media (max-width: 390px) {
    .tasks-list {
      gap: 6px;
    }
  }
  
  .task-card {
    position: relative;
    background: #ffffff;
    border: 2px solid #e2e8f0;
    border-radius: 8px;
    overflow: hidden;
    transition: all 0.3s ease;
  }
  
  .task-card.blocker {
    border-color: #e53e3e;
  }
  
  .task-card.expired {
    background-color: #ffcccc;
  }
  
  .task-card.expired .task-name {
    color: #2d3748;
  }
  
  .task-card.postponed {
    background-color: #cbd5e0;
  }
  
  .task-card.in-progress {
    background-color: #2c5282;
  }
  
  .task-card.in-progress .task-name {
    color: #ffffff;
  }
  
  .task-card.queued {
    background-color: #bee3f8;
  }
  
  .task-card.queued.expired {
    background-color: #ffcccc;
  }
  
  .task-progress {
    position: absolute;
    top: 0;
    bottom: 0;
    transition: width 0.3s ease;
    z-index: 1;
  }
  
  .task-card.general .task-progress {
    background-color: #fef9c3;
  }
  
  .task-card.general.expired .task-progress {
    background-color: #fecaca;
  }
  
  .task-card.personal.queued .task-progress {
    background-color: #4299e1;
  }
  
  .task-card.personal .task-progress {
    background-color: #e6f7ff;
  }
  
  .task-card.personal.expired .task-progress {
    background-color: transparent;
  }
  
  .task-content {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    padding: 12px;
    gap: 12px;
  }
  
  @media (max-width: 390px) {
    .task-content {
      padding: 6px;
      gap: 6px;
    }
  }
  
  .reverse-timer-btn {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border: none;
    background-color: transparent;
    color: #4a5568;
    font-size: 18px;
    cursor: pointer;
    border-radius: 4px;
    transition: background-color 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .reverse-timer-btn:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
  
  @media (max-width: 390px) {
    .reverse-timer-btn {
      display: none;
    }
  }
  
  .task-timer {
    flex-shrink: 0;
    font-size: 13px;
    font-weight: 600;
    color: #2d3748;
    white-space: nowrap;
    background-color: #ffd700;
    padding: 4px 8px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    height: 32px;
  }
  
  @media (max-width: 390px) {
    .task-timer {
      font-size: 10px;
      padding: 2px 5px;
      height: 24px;
    }
  }
  
  .task-card.blocker .task-timer {
    border: 2px solid #e53e3e;
  }
  
  .task-expired-time {
    flex-shrink: 0;
    font-size: 13px;
    font-weight: 600;
    color: #c53030;
    white-space: nowrap;
    background-color: transparent;
    padding: 4px 8px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    height: 32px;
  }
  
  @media (max-width: 390px) {
    .task-expired-time {
      font-size: 10px;
      padding: 2px 5px;
      height: 24px;
    }
  }
  
  .task-startdate {
    flex-shrink: 0;
    background-color: #ff9800;
    color: #c53030;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
    height: 32px;
    white-space: nowrap;
  }
  
  @media (max-width: 390px) {
    .task-startdate {
      font-size: 9px;
      padding: 2px 5px;
      height: 24px;
    }
  }
  
  .task-info {
    flex: 1 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  
  .task-name {
    font-size: 14px;
    font-weight: 500;
    color: #2d3748;
    word-wrap: break-word;
    line-height: 1.4;
    white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
}
  
  @media (max-width: 390px) {
    .task-name {
      font-size: 11px;
      line-height: 1.3;
    }
  }
  
  .task-actions {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .task-link-btn {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #4299e1;
    color: white;
    border-radius: 4px;
    text-decoration: none;
    font-size: 18px;
    transition: background-color 0.2s;
  }
  
  .task-link-btn:hover {
    background-color: #3182ce;
  }
  
  @media (max-width: 390px) {
    .task-link-btn {
      display: none;
    }
  }
  
  .no-tasks {
    text-align: center;
    padding: 40px 20px;
    color: #718096;
    font-size: 16px;
  }
  
  @media (max-width: 390px) {
    .no-tasks {
      padding: 0px 10px;
      font-size: 13px;
    }
  }
  
  .loading, .error {
    text-align: center;

    font-size: 18px;
  }
  

  
  .error {
    color: #e53e3e;
  }
  
  .pip-toggle-btn {
    position: fixed;
    bottom: 20px;
    right: 20px;
   
    display: flex;
    align-items: center;
    gap: 8px;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    padding: 8px 12px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s ease;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 1000;
  }
  
  .pip-toggle-btn:hover {
    background: #f8fafc;
    border-color: #cbd5e0;
  }
  
  @media (max-width: 590px) {
    .pip-toggle-btn {
      font-size: 12px;
      padding: 6px 10px;
      bottom: 15px;
      right: 15px;
    }
  }
  .users-tasks-page .task-times-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-top: 4px;
  }
  
  .users-tasks-page .total-time-in-status {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 11px;
    color: #666;
  }
  
  .users-tasks-page .planned-time-remaining {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  
  .users-tasks-page .time-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 11px;
  }
  
  .users-tasks-page .time-label {
    font-weight: 600;
    color: #555;
  }
  
  .users-tasks-page .time-value {
    font-weight: 500;
  }
  
  .users-tasks-page .task-blocker {
    font-size: 10px;
    color: #d32f2f;
    font-weight: bold;
    margin-top: 4px;
    padding: 1px 6px;
    background-color: rgba(255, 0, 0, 0.1);
    border-radius: 10px;
    display: inline-block;
  }

  .task-status-info {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    color: #666;
    margin-top: 2px;
  }
  
  @media (max-width: 790px) {
    .task-status-info {
      font-size: 9px;
      gap: 2px;
    }
  }
  
  .task-status-label {
    font-weight: 600;
  }
  
  .task-status-time {
    font-weight: 500;
    color: #4299e1;
  }
  
  /* Стилі для таймера статусу */
  .status-timer {
    background-color: #48bb78 !important;
    color: white !important;
  }
  
  /* Приховування кнопки PiP Mode на ширині менше 390px */
  @media (max-width: 790px) {
    .pip-toggle-btn {
      display: none !important;
    }
  }
  
  /* Додаткові стилі для кращого відображення */
  .task-card.in-progress .task-status-info,
  .task-card.queued .task-status-info {
    color: rgba(255, 255, 255, 0.9);
  }
  
  .task-card.in-progress .task-status-time,
  .task-card.queued .task-status-time {
    color: #ffd700;
  }

  /* Базові стилі для світлої теми (дефолтні) */
.tasks-page {
    padding: 20px;
    background-color: #f5f5f5;
    min-height: 100vh;
    transition: background-color 0.3s ease;
  }
  
  /* Стилі для темної теми */
  .tasks-page.dark-theme {
    background-color: #1a202c;
  }
  
  .tasks-page.dark-theme .pool-section {
    background-color: #414752;
  }
  
  .tasks-page.dark-theme .pool-title-m {
    color: #e2e8f0;
  }
  
  .tasks-page.dark-theme .task-count-m {
    color: #a0aec0;
  }
  
  .tasks-page.dark-theme .no-tasks {
    color: #a0aec0;
  }
  
  .tasks-page.dark-theme .loading,
  .tasks-page.dark-theme .error {
    color: #e2e8f0;
  }
  
  /* Загальні контейнери пулів залишаються незмінними */
  .pool-section {
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 0px;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    transition: background-color 0.3s ease;
  }
  
  /* Контейнери задач залишаються незмінними */
  .task-card {
    position: relative;
    background: #ffffff;
    border: 2px solid #e2e8f0;
    border-radius: 8px;
    overflow: hidden;
    transition: all 0.3s ease;
  }
  
  /* Усі інші стилі залишаються незмінними як були */
  
  @media (max-width: 390px) {
    .tasks-page {
      padding: 10px;
    }
  }
  
  @media (max-width: 390px) {
    .pool-section {
      padding: 12px;
      margin-bottom: 0px;
    }
  }
  
  .pool-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
  }
  
  @media (max-width: 390px) {
    .pool-header {
      margin-bottom: 6px;
    }
  }

  .pool-header-left {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .pool-title-m {
    font-size: 18px;
    font-weight: 600;
    color: #2d3748;
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0;
  }
  
  @media (max-width: 1000px) {
    .pool-title-m {
      font-size: 15px;
      font-weight: 20;
    }
  }
  
  @media (max-width: 390px) {
    .pool-title-m {
      font-size: 10px;
    }
  }
  
  .task-count-m {
    font-size: 18px;
    color: #718096;
    font-weight: 500;
  }
  
  @media (max-width: 390px) {
    .task-count-m {
      font-size: 9px;
    }
  }
  
  .collapse-btn {
    background-color: #4299e1;
    color: white;
    border: none;
    border-radius: 6px;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.2s;
  }
  
  @media (max-width: 390px) {
    .collapse-btn {
      width: 28px;
      height: 28px;
      font-size: 14px;
    }
  }
  
  .collapse-btn:hover {
    background-color: #3182ce;
  }
  
  .tasks-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  
  @media (max-width: 390px) {
    .tasks-list {
      gap: 6px;
    }
  }
  
  .task-card.blocker {
    border-color: #e53e3e;
  }
  
  .task-card.expired {
    background-color: #ffcccc;
  }
  
  .task-card.expired .task-name {
    color: #2d3748;
  }
  
  .task-card.postponed {
    background-color: #cbd5e0;
  }
  
  .task-card.in-progress {
    background-color: #2c5282;
  }
  
  .task-card.in-progress .task-name {
    color: #ffffff;
  }
  
  .task-card.queued {
    background-color: #bee3f8;
  }
  
  .task-card.queued.expired {
    background-color: #ffcccc;
  }
  
  .task-progress {
    position: absolute;
    top: 0;
    bottom: 0;
    transition: width 0.3s ease;
    z-index: 1;
  }
  
  .task-card.general .task-progress {
    background-color: #fef9c3;
  }
  
  .task-card.general.expired .task-progress {
    background-color: #fecaca;
  }
  
  .task-card.personal.queued .task-progress {
    background-color: #4299e1;
  }
  
  .task-card.personal .task-progress {
    background-color: #e6f7ff;
  }
  
  .task-card.personal.expired .task-progress {
    background-color: transparent;
  }
  
  .task-content {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    padding: 12px;
    gap: 12px;
  }
  
  @media (max-width: 390px) {
    .task-content {
      padding: 6px;
      gap: 6px;
    }
  }
  
  .reverse-timer-btn {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border: none;
    background-color: transparent;
    color: #4a5568;
    font-size: 18px;
    cursor: pointer;
    border-radius: 4px;
    transition: background-color 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .reverse-timer-btn:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
  
  @media (max-width: 390px) {
    .reverse-timer-btn {
      display: none;
    }
  }
  
  .task-timer {
    flex-shrink: 0;
    font-size: 13px;
    font-weight: 600;
    color: #2d3748;
    white-space: nowrap;
    background-color: #ffd700;
    padding: 4px 8px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    height: 32px;
  }
  
  @media (max-width: 390px) {
    .task-timer {
      font-size: 10px;
      padding: 2px 5px;
      height: 24px;
    }
  }
  
  .task-card.blocker .task-timer {
    border: 2px solid #e53e3e;
  }
  
  .task-expired-time {
    flex-shrink: 0;
    font-size: 13px;
    font-weight: 600;
    color: #c53030;
    white-space: nowrap;
    background-color: transparent;
    padding: 4px 8px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    height: 32px;
  }
  
  @media (max-width: 390px) {
    .task-expired-time {
      font-size: 10px;
      padding: 2px 5px;
      height: 24px;
    }
  }
  
  .task-startdate {
    flex-shrink: 0;
    background-color: #ff9800;
    color: #c53030;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
    height: 32px;
    white-space: nowrap;
  }
  
  @media (max-width: 390px) {
    .task-startdate {
      font-size: 9px;
      padding: 2px 5px;
      height: 24px;
    }
  }
  
  .task-info {
    flex: 1 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  
  .task-name {
    font-size: 14px;
    font-weight: 500;
    color: #2d3748;
    word-wrap: break-word;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  @media (max-width: 390px) {
    .task-name {
      font-size: 11px;
      line-height: 1.3;
    }
  }
  
  .task-actions {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .task-link-btn {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #4299e1;
    color: white;
    border-radius: 4px;
    text-decoration: none;
    font-size: 18px;
    transition: background-color 0.2s;
  }
  
  .task-link-btn:hover {
    background-color: #3182ce;
  }
  
  @media (max-width: 390px) {
    .task-link-btn {
      display: none;
    }
  }
  
  .no-tasks {
    text-align: center;
    padding: 40px 20px;
    color: #718096;
    font-size: 16px;
  }
  
  @media (max-width: 390px) {
    .no-tasks {
      padding: 0px 10px;
      font-size: 13px;
    }
  }
  
  .loading, .error {
    text-align: center;
    font-size: 18px;
  }
  
  .error {
    color: #e53e3e;
  }
  
  .pip-toggle-btn {
    position: fixed;
    bottom: 20px;
    right: 20px;
    display: flex;
    align-items: center;
    gap: 8px;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    padding: 8px 12px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s ease;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 1000;
  }
  
  .tasks-page.dark-theme .pip-toggle-btn {
    background: #2d3748;
    border-color: #969aa1;
    color: #e2e8f0;
  }
  
  .pip-toggle-btn:hover {
    background: #f8fafc;
    border-color: #cbd5e0;
  }
  
  .tasks-page.dark-theme .pip-toggle-btn:hover {
    background: #7b8391;
    border-color: #718096;
  }
  
  @media (max-width: 590px) {
    .pip-toggle-btn {
      font-size: 12px;
      padding: 6px 10px;
      bottom: 15px;
      right: 15px;
    }
  }
  .users-tasks-page .task-times-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-top: 4px;
  }
  
  .users-tasks-page .total-time-in-status {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 11px;
    color: #666;
  }
  
  .users-tasks-page .planned-time-remaining {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  
  .users-tasks-page .time-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 11px;
  }
  
  .users-tasks-page .time-label {
    font-weight: 600;
    color: #555;
  }
  
  .users-tasks-page .time-value {
    font-weight: 500;
  }
  
  .users-tasks-page .task-blocker {
    font-size: 10px;
    color: #d32f2f;
    font-weight: bold;
    margin-top: 4px;
    padding: 1px 6px;
    background-color: rgba(255, 0, 0, 0.1);
    border-radius: 10px;
    display: inline-block;
  }

  .task-status-info {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    color: #666;
    margin-top: 2px;
  }
  
  @media (max-width: 790px) {
    .task-status-info {
      font-size: 9px;
      gap: 2px;
    }
  }
  
  .task-status-label {
    font-weight: 600;
  }
  
  .task-status-time {
    font-weight: 500;
    color: #4299e1;
  }
  
  /* Стилі для таймера статусу */
  .status-timer {
    background-color: #48bb78 !important;
    color: white !important;
  }
  
  /* Приховування кнопки PiP Mode на ширині менше 390px */
  @media (max-width: 790px) {
    .pip-toggle-btn {
      display: none !important;
    }
  }
  
  /* Додаткові стилі для кращого відображення */
  .task-card.in-progress .task-status-info,
  .task-card.queued .task-status-info {
    color: rgba(255, 255, 255, 0.9);
  }
  
  .task-card.in-progress .task-status-time,
  .task-card.queued .task-status-time {
    color: #ffd700;
  }

  /* Стилі для сповіщення як overlay */
.notification-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    animation: fadeIn 0.3s ease;
  }
  
  .notification-popup {
    background: white;
    border-radius: 12px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    width: 90%;
    max-width: 400px;
    animation: slideIn 0.3s ease;
  }
  
  .tasks-page.dark-theme .notification-popup {
    background: #2d3748;
    border: 1px solid #4a5568;
  }
  
  .notification-content {
    padding: 24px;
  }
  
  .notification-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
    position: relative;
  }
  
  .notification-icon {
    font-size: 28px;
  }
  
  .notification-title {
    font-size: 20px;
    font-weight: 600;
    color: #2d3748;
    flex: 1 1;
  }
  
  .tasks-page.dark-theme .notification-title {
    color: #e2e8f0;
  }
  
  .notification-close {
    position: absolute;
    top: -8px;
    right: -8px;
    width: 32px;
    height: 32px;
    border: none;
    background: #e2e8f0;
    color: #4a5568;
    font-size: 20px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
  }
  
  .notification-close:hover {
    background: #cbd5e0;
    transform: scale(1.1);
  }
  
  .tasks-page.dark-theme .notification-close {
    background: #4a5568;
    color: #e2e8f0;
  }
  
  .tasks-page.dark-theme .notification-close:hover {
    background: #718096;
  }
  
  .notification-body {
    margin-bottom: 24px;
  }
  
  .notification-body p {
    margin: 8px 0;
    color: #4a5568;
    font-size: 16px;
    line-height: 1.5;
  }
  
  .tasks-page.dark-theme .notification-body p {
    color: #cbd5e0;
  }
  
  .notification-task-name {
    font-weight: 600;
    color: #2d3748 !important;
    font-size: 18px !important;
    padding: 12px;
    background: #f7fafc;
    border-radius: 8px;
    border-left: 4px solid #4299e1;
    word-break: break-word;
  }
  
  .tasks-page.dark-theme .notification-task-name {
    background: #4a5568;
    color: #e2e8f0 !important;
    border-left-color: #63b3ed;
  }
  
  .notification-time {
    color: #e53e3e !important;
    font-weight: 600;
    font-size: 18px !important;
    text-align: center;
    margin-top: 16px !important;
  }
  
  .notification-actions {
    display: flex;
    gap: 12px;
    justify-content: center;
  }
  
  .notification-btn {
    padding: 12px 24px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    flex: 1 1;
    max-width: 150px;
  }
  
  .notification-btn.ok {
    background: #4299e1;
    color: white;
  }
  
  .notification-btn.ok:hover {
    background: #3182ce;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(66, 153, 225, 0.4);
  }
  
  .notification-btn.no-help {
    background: #48bb78;
    color: white;
  }
  
  .notification-btn.no-help:hover {
    background: #38a169;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(72, 187, 120, 0.4);
  }
  
  .tasks-page.dark-theme .notification-btn.ok {
    background: #2b6cb0;
  }
  
  .tasks-page.dark-theme .notification-btn.ok:hover {
    background: #2c5282;
  }
  
  .tasks-page.dark-theme .notification-btn.no-help {
    background: #2f855a;
  }
  
  .tasks-page.dark-theme .notification-btn.no-help:hover {
    background: #276749;
  }
  
  /* Анімації */
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  
  @keyframes slideIn {
    from {
      transform: translateY(-50px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  
  /* Стилі для кнопки "Допомога не потрібна" на картці задачі */
  .no-help-btn {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border: none;
    background-color: #e2e8f0;
    color: #4a5568;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    border-radius: 4px;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.5;
  }
  
  .no-help-btn.active {
    opacity: 1;
    background-color: #48bb78;
    color: white;
  }
  
  .no-help-btn.active:hover {
    background-color: #38a169;
    transform: scale(1.1);
  }
  
  .no-help-btn.marked {
    background-color: #48bb78;
    color: white;
    opacity: 1;
    cursor: default;
  }
  
  .no-help-btn:disabled {
    cursor: not-allowed;
  }
  
  .task-card.in-progress .no-help-btn.active {
    background-color: #48bb78;
    color: white;
  }
  
  .task-card.in-progress .no-help-btn {
    background-color: rgba(255, 255, 255, 0.2);
    color: white;
  }
  
  @media (max-width: 390px) {
    .no-help-btn {
      width: 24px;
      height: 24px;
      font-size: 12px;
    }
  }
  
  /* Стилі для кнопки "Запитати допомогу" */
.ask-help-btn {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border: none;
  background-color: #e2e8f0;
  color: #4a5568;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ask-help-btn:hover {
  background-color: #cbd5e0;
  transform: scale(1.05);
}

.ask-help-btn.marked {
  background-color: #ed8936;
  color: white;
}

.ask-help-btn.marked:hover {
  background-color: #dd6b20;
  transform: scale(1.05);
}

.task-card.in-progress .ask-help-btn {
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
}

.task-card.in-progress .ask-help-btn:hover {
  background-color: rgba(255, 255, 255, 0.3);
}

.task-card.in-progress .ask-help-btn.marked {
  background-color: #ed8936;
  color: white;
}

@media (max-width: 390px) {
  .ask-help-btn {
    width: 24px;
    height: 24px;
    font-size: 12px;
  }
}

/* Стилі для пулу задач з запитом про допомогу */
.ask-help-pool {
  border-left: 3px solid #ed8936;
}

.tasks-page.dark-theme .ask-help-pool {
  border-left-color: #dd6b20;
}
`, "",{"version":3,"sources":["webpack://./src/components/covfile/TasksPage.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,gDAAgD;AAChD;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,2DAA2D;AAC3D;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,oEAAoE;AACpE;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,6DAA6D;AAC7D;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,kEAAkE;AAClE;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,uDAAuD;AACvD;EACE;IACE,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,cAAc;EAChB;;EAEA;;;IAGE,cAAc;IACd,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,0DAA0D;AAC1D;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;;;IAGE,eAAe;IACf,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,iBAAiB;;EAEnB;;EAEA;IACE;MACE,aAAa;IACf;EACF;;EAEA;;IAEE,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,wCAAwC;IACxC,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE;MACE,aAAa;MACb,kBAAkB;IACpB;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE;MACE,kBAAkB;IACpB;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,SAAS;EACX;;EAEA;IACE;MACE,eAAe;MACf,eAAe;IACjB;EACF;;EAEA;IACE;MACE,eAAe;IACjB;EACF;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE;MACE,cAAc;IAChB;EACF;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE;MACE,WAAW;MACX,YAAY;MACZ,eAAe;IACjB;EACF;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE;MACE,QAAQ;IACV;EACF;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,SAAS;EACX;;EAEA;IACE;MACE,YAAY;MACZ,QAAQ;IACV;EACF;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,cAAc;IACd,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE;MACE,aAAa;IACf;EACF;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE;MACE,eAAe;MACf,gBAAgB;MAChB,YAAY;IACd;EACF;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE;MACE,eAAe;MACf,gBAAgB;MAChB,YAAY;IACd;EACF;;EAEA;IACE,cAAc;IACd,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE;MACE,cAAc;MACd,gBAAgB;MAChB,YAAY;IACd;EACF;;EAEA;IACE,SAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;AACvB,gBAAgB;AAChB,uBAAuB;AACvB;;EAEE;IACE;MACE,eAAe;MACf,gBAAgB;IAClB;EACF;;EAEA;IACE,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE;MACE,aAAa;IACf;EACF;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE;MACE,iBAAiB;MACjB,eAAe;IACjB;EACF;;EAEA;IACE,kBAAkB;;IAElB,eAAe;EACjB;;;;EAIA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,WAAW;;IAEX,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,0CAA0C;IAC1C,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE;MACE,eAAe;MACf,iBAAiB;MACjB,YAAY;MACZ,WAAW;IACb;EACF;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,WAAW;IACX,eAAe;EACjB;;EAEA;IACE;MACE,cAAc;MACd,QAAQ;IACV;EACF;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA,8BAA8B;EAC9B;IACE,oCAAoC;IACpC,uBAAuB;EACzB;;EAEA,uDAAuD;EACvD;IACE;MACE,wBAAwB;IAC1B;EACF;;EAEA,6CAA6C;EAC7C;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,cAAc;EAChB;;EAEA,6CAA6C;AAC/C;IACI,aAAa;IACb,yBAAyB;IACzB,iBAAiB;IACjB,sCAAsC;EACxC;;EAEA,0BAA0B;EAC1B;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,cAAc;EAChB;;EAEA,qDAAqD;EACrD;IACE,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,wCAAwC;IACxC,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,sCAAsC;EACxC;;EAEA,4CAA4C;EAC5C;IACE,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA,kDAAkD;;EAElD;IACE;MACE,aAAa;IACf;EACF;;EAEA;IACE;MACE,aAAa;MACb,kBAAkB;IACpB;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE;MACE,kBAAkB;IACpB;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,SAAS;EACX;;EAEA;IACE;MACE,eAAe;MACf,eAAe;IACjB;EACF;;EAEA;IACE;MACE,eAAe;IACjB;EACF;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE;MACE,cAAc;IAChB;EACF;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE;MACE,WAAW;MACX,YAAY;MACZ,eAAe;IACjB;EACF;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE;MACE,QAAQ;IACV;EACF;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,SAAS;EACX;;EAEA;IACE;MACE,YAAY;MACZ,QAAQ;IACV;EACF;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,cAAc;IACd,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE;MACE,aAAa;IACf;EACF;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE;MACE,eAAe;MACf,gBAAgB;MAChB,YAAY;IACd;EACF;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE;MACE,eAAe;MACf,gBAAgB;MAChB,YAAY;IACd;EACF;;EAEA;IACE,cAAc;IACd,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE;MACE,cAAc;MACd,gBAAgB;MAChB,YAAY;IACd;EACF;;EAEA;IACE,SAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE;MACE,eAAe;MACf,gBAAgB;IAClB;EACF;;EAEA;IACE,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE;MACE,aAAa;IACf;EACF;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE;MACE,iBAAiB;MACjB,eAAe;IACjB;EACF;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,0CAA0C;IAC1C,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE;MACE,eAAe;MACf,iBAAiB;MACjB,YAAY;MACZ,WAAW;IACb;EACF;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,WAAW;IACX,eAAe;EACjB;;EAEA;IACE;MACE,cAAc;MACd,QAAQ;IACV;EACF;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA,8BAA8B;EAC9B;IACE,oCAAoC;IACpC,uBAAuB;EACzB;;EAEA,uDAAuD;EACvD;IACE;MACE,wBAAwB;IAC1B;EACF;;EAEA,6CAA6C;EAC7C;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,cAAc;EAChB;;EAEA,oCAAoC;AACtC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,UAAU;IACV,gBAAgB;IAChB,4BAA4B;EAC9B;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAO;EACT;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,SAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,8CAA8C;EAChD;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,8CAA8C;EAChD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,aAAa;EACb;IACE;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,4BAA4B;MAC5B,UAAU;IACZ;IACA;MACE,wBAAwB;MACxB,UAAU;IACZ;EACF;;EAEA,6DAA6D;EAC7D;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,UAAU;IACV,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,0CAA0C;IAC1C,YAAY;EACd;;EAEA;IACE;MACE,WAAW;MACX,YAAY;MACZ,eAAe;IACjB;EACF;;EAEA,yCAAyC;AAC3C;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,gDAAgD;AAChD;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["/* Стилі для кнопки \"Запитати допомогу\" */\r\n.ask-help-btn {\r\n  flex-shrink: 0;\r\n  width: 32px;\r\n  height: 32px;\r\n  border: none;\r\n  background-color: #e2e8f0;\r\n  color: #4a5568;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n  transition: all 0.2s;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.ask-help-btn:hover {\r\n  background-color: #cbd5e0;\r\n  transform: scale(1.05);\r\n}\r\n\r\n.ask-help-btn.marked {\r\n  background-color: #ed8936;\r\n  color: white;\r\n}\r\n\r\n.ask-help-btn.marked:hover {\r\n  background-color: #dd6b20;\r\n  transform: scale(1.05);\r\n}\r\n\r\n.task-card.in-progress .ask-help-btn {\r\n  background-color: rgba(255, 255, 255, 0.2);\r\n  color: white;\r\n}\r\n\r\n.task-card.in-progress .ask-help-btn:hover {\r\n  background-color: rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n.task-card.in-progress .ask-help-btn.marked {\r\n  background-color: #ed8936;\r\n  color: white;\r\n}\r\n\r\n/* Стилі для пулу задач з запитом про допомогу */\r\n.ask-help-pool {\r\n  border-left: 3px solid #ed8936;\r\n}\r\n\r\n.tasks-page.dark-theme .ask-help-pool {\r\n  border-left-color: #dd6b20;\r\n}\r\n\r\n/* Приховування кнопок на маленьких екранах (менше 590px) */\r\n@media (max-width: 590px) {\r\n  .ask-help-btn {\r\n    display: none !important;\r\n  }\r\n  \r\n  .no-help-btn {\r\n    display: none !important;\r\n  }\r\n  \r\n  .reverse-timer-btn {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n/* Для екранів від 391px до 590px - приховуємо тільки деякі кнопки */\r\n@media (min-width: 391px) and (max-width: 590px) {\r\n  .ask-help-btn {\r\n    width: 28px;\r\n    height: 28px;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .no-help-btn {\r\n    width: 28px;\r\n    height: 28px;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .reverse-timer-btn {\r\n    width: 28px;\r\n    height: 28px;\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n/* Для екранів менше 390px - всі додаткові кнопки приховані */\r\n@media (max-width: 390px) {\r\n  .ask-help-btn {\r\n    display: none !important;\r\n  }\r\n  \r\n  .no-help-btn {\r\n    display: none !important;\r\n  }\r\n  \r\n  .reverse-timer-btn {\r\n    display: none !important;\r\n  }\r\n  \r\n  .task-link-btn {\r\n    display: none !important;\r\n  }\r\n  \r\n  .task-timer {\r\n    font-size: 8px;\r\n    padding: 2px 4px;\r\n    height: 20px;\r\n  }\r\n  \r\n  .task-expired-time {\r\n    font-size: 8px;\r\n    padding: 2px 4px;\r\n    height: 20px;\r\n  }\r\n  \r\n  .task-startdate {\r\n    font-size: 8px;\r\n    padding: 2px 4px;\r\n    height: 20px;\r\n  }\r\n  \r\n  .task-name {\r\n    font-size: 10px;\r\n  }\r\n}\r\n\r\n/* Стилі для кнопки PiP Mode - приховуємо на екранах менше 790px */\r\n@media (max-width: 790px) {\r\n  .pip-toggle-btn {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n/* Адаптація для дуже маленьких екранів (менше 320px) */\r\n@media (max-width: 320px) {\r\n  .task-content {\r\n    padding: 4px;\r\n    gap: 4px;\r\n  }\r\n  \r\n  .task-name {\r\n    font-size: 9px;\r\n  }\r\n  \r\n  .task-timer,\r\n  .task-expired-time,\r\n  .task-startdate {\r\n    font-size: 7px;\r\n    padding: 1px 3px;\r\n    height: 18px;\r\n  }\r\n  \r\n  .pool-title-m {\r\n    font-size: 9px;\r\n  }\r\n  \r\n  .task-count-m {\r\n    font-size: 8px;\r\n  }\r\n  \r\n  .collapse-btn {\r\n    width: 24px;\r\n    height: 24px;\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n/* Додаткові стилі для кращого відображення на планшетах */\r\n@media (min-width: 591px) and (max-width: 790px) {\r\n  .ask-help-btn {\r\n    width: 30px;\r\n    height: 30px;\r\n    font-size: 15px;\r\n  }\r\n  \r\n  .no-help-btn {\r\n    width: 30px;\r\n    height: 30px;\r\n    font-size: 15px;\r\n  }\r\n  \r\n  .reverse-timer-btn {\r\n    width: 30px;\r\n    height: 30px;\r\n    font-size: 15px;\r\n  }\r\n  \r\n  .task-timer,\r\n  .task-expired-time,\r\n  .task-startdate {\r\n    font-size: 11px;\r\n    padding: 3px 6px;\r\n    height: 28px;\r\n  }\r\n  \r\n  .task-name {\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n/* Стилі для темної теми кнопок */\r\n.tasks-page.dark-theme .ask-help-btn {\r\n  background-color: #4a5568;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.tasks-page.dark-theme .ask-help-btn:hover {\r\n  background-color: #718096;\r\n}\r\n\r\n.tasks-page.dark-theme .ask-help-btn.marked {\r\n  background-color: #dd6b20;\r\n  color: white;\r\n}\r\n\r\n.tasks-page.dark-theme .no-help-btn {\r\n  background-color: #4a5568;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.tasks-page.dark-theme .no-help-btn.active {\r\n  background-color: #48bb78;\r\n  color: white;\r\n}\r\n\r\n.tasks-page.dark-theme .no-help-btn.marked {\r\n  background-color: #48bb78;\r\n  color: white;\r\n}\r\n\r\n.tasks-page.dark-theme .reverse-timer-btn {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.tasks-page.dark-theme .reverse-timer-btn:hover {\r\n  background-color: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.tasks-page {\r\n    padding: 20px;\r\n    background-color: #f5f5f5;\r\n    min-height: 100vh;\r\n   \r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .tasks-page {\r\n      padding: 10px;\r\n    }\r\n  }\r\n  \r\n  .pool-section {\r\n    \r\n    background: white;\r\n    border-radius: 12px;\r\n    padding: 20px;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n    margin-bottom: 0px;\r\n    max-width: 1200px;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .pool-section {\r\n      padding: 12px;\r\n      margin-bottom: 0px;\r\n    }\r\n  }\r\n  \r\n  .pool-header {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    margin-bottom: 12px;\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .pool-header {\r\n      margin-bottom: 6px;\r\n    }\r\n  }\r\n\r\n  .pool-header-left {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n  }\r\n  .pool-title-m {\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    color: #2d3748;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    margin: 0;\r\n  }\r\n  \r\n  @media (max-width: 1000px) {\r\n    .pool-title-m {\r\n      font-size: 15px;\r\n      font-weight: 20;\r\n    }\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .pool-title-m {\r\n      font-size: 10px;\r\n    }\r\n  }\r\n  \r\n  .task-count-m {\r\n    font-size: 18px;\r\n    color: #718096;\r\n    font-weight: 500;\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .task-count-m {\r\n      font-size: 9px;\r\n    }\r\n  }\r\n  \r\n  .collapse-btn {\r\n    background-color: #4299e1;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 6px;\r\n    width: 36px;\r\n    height: 36px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n    transition: background-color 0.2s;\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .collapse-btn {\r\n      width: 28px;\r\n      height: 28px;\r\n      font-size: 14px;\r\n    }\r\n  }\r\n  \r\n  .collapse-btn:hover {\r\n    background-color: #3182ce;\r\n  }\r\n  \r\n  .tasks-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 12px;\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .tasks-list {\r\n      gap: 6px;\r\n    }\r\n  }\r\n  \r\n  .task-card {\r\n    position: relative;\r\n    background: #ffffff;\r\n    border: 2px solid #e2e8f0;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    transition: all 0.3s ease;\r\n  }\r\n  \r\n  .task-card.blocker {\r\n    border-color: #e53e3e;\r\n  }\r\n  \r\n  .task-card.expired {\r\n    background-color: #ffcccc;\r\n  }\r\n  \r\n  .task-card.expired .task-name {\r\n    color: #2d3748;\r\n  }\r\n  \r\n  .task-card.postponed {\r\n    background-color: #cbd5e0;\r\n  }\r\n  \r\n  .task-card.in-progress {\r\n    background-color: #2c5282;\r\n  }\r\n  \r\n  .task-card.in-progress .task-name {\r\n    color: #ffffff;\r\n  }\r\n  \r\n  .task-card.queued {\r\n    background-color: #bee3f8;\r\n  }\r\n  \r\n  .task-card.queued.expired {\r\n    background-color: #ffcccc;\r\n  }\r\n  \r\n  .task-progress {\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    transition: width 0.3s ease;\r\n    z-index: 1;\r\n  }\r\n  \r\n  .task-card.general .task-progress {\r\n    background-color: #fef9c3;\r\n  }\r\n  \r\n  .task-card.general.expired .task-progress {\r\n    background-color: #fecaca;\r\n  }\r\n  \r\n  .task-card.personal.queued .task-progress {\r\n    background-color: #4299e1;\r\n  }\r\n  \r\n  .task-card.personal .task-progress {\r\n    background-color: #e6f7ff;\r\n  }\r\n  \r\n  .task-card.personal.expired .task-progress {\r\n    background-color: transparent;\r\n  }\r\n  \r\n  .task-content {\r\n    position: relative;\r\n    z-index: 2;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 12px;\r\n    gap: 12px;\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .task-content {\r\n      padding: 6px;\r\n      gap: 6px;\r\n    }\r\n  }\r\n  \r\n  .reverse-timer-btn {\r\n    flex-shrink: 0;\r\n    width: 32px;\r\n    height: 32px;\r\n    border: none;\r\n    background-color: transparent;\r\n    color: #4a5568;\r\n    font-size: 18px;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n    transition: background-color 0.2s;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .reverse-timer-btn:hover {\r\n    background-color: rgba(0, 0, 0, 0.05);\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .reverse-timer-btn {\r\n      display: none;\r\n    }\r\n  }\r\n  \r\n  .task-timer {\r\n    flex-shrink: 0;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    color: #2d3748;\r\n    white-space: nowrap;\r\n    background-color: #ffd700;\r\n    padding: 4px 8px;\r\n    border-radius: 4px;\r\n    display: flex;\r\n    align-items: center;\r\n    height: 32px;\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .task-timer {\r\n      font-size: 10px;\r\n      padding: 2px 5px;\r\n      height: 24px;\r\n    }\r\n  }\r\n  \r\n  .task-card.blocker .task-timer {\r\n    border: 2px solid #e53e3e;\r\n  }\r\n  \r\n  .task-expired-time {\r\n    flex-shrink: 0;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    color: #c53030;\r\n    white-space: nowrap;\r\n    background-color: transparent;\r\n    padding: 4px 8px;\r\n    border-radius: 4px;\r\n    display: flex;\r\n    align-items: center;\r\n    height: 32px;\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .task-expired-time {\r\n      font-size: 10px;\r\n      padding: 2px 5px;\r\n      height: 24px;\r\n    }\r\n  }\r\n  \r\n  .task-startdate {\r\n    flex-shrink: 0;\r\n    background-color: #ff9800;\r\n    color: #c53030;\r\n    padding: 4px 8px;\r\n    border-radius: 4px;\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    display: flex;\r\n    align-items: center;\r\n    height: 32px;\r\n    white-space: nowrap;\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .task-startdate {\r\n      font-size: 9px;\r\n      padding: 2px 5px;\r\n      height: 24px;\r\n    }\r\n  }\r\n  \r\n  .task-info {\r\n    flex: 1;\r\n    min-width: 0;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 4px;\r\n  }\r\n  \r\n  .task-name {\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    color: #2d3748;\r\n    word-wrap: break-word;\r\n    line-height: 1.4;\r\n    white-space: nowrap;\r\noverflow: hidden;\r\ntext-overflow: ellipsis;\r\n}\r\n  \r\n  @media (max-width: 390px) {\r\n    .task-name {\r\n      font-size: 11px;\r\n      line-height: 1.3;\r\n    }\r\n  }\r\n  \r\n  .task-actions {\r\n    flex-shrink: 0;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n  }\r\n  \r\n  .task-link-btn {\r\n    width: 32px;\r\n    height: 32px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: #4299e1;\r\n    color: white;\r\n    border-radius: 4px;\r\n    text-decoration: none;\r\n    font-size: 18px;\r\n    transition: background-color 0.2s;\r\n  }\r\n  \r\n  .task-link-btn:hover {\r\n    background-color: #3182ce;\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .task-link-btn {\r\n      display: none;\r\n    }\r\n  }\r\n  \r\n  .no-tasks {\r\n    text-align: center;\r\n    padding: 40px 20px;\r\n    color: #718096;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .no-tasks {\r\n      padding: 0px 10px;\r\n      font-size: 13px;\r\n    }\r\n  }\r\n  \r\n  .loading, .error {\r\n    text-align: center;\r\n\r\n    font-size: 18px;\r\n  }\r\n  \r\n\r\n  \r\n  .error {\r\n    color: #e53e3e;\r\n  }\r\n  \r\n  .pip-toggle-btn {\r\n    position: fixed;\r\n    bottom: 20px;\r\n    right: 20px;\r\n   \r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    background: white;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 6px;\r\n    padding: 8px 12px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    transition: all 0.2s ease;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .pip-toggle-btn:hover {\r\n    background: #f8fafc;\r\n    border-color: #cbd5e0;\r\n  }\r\n  \r\n  @media (max-width: 590px) {\r\n    .pip-toggle-btn {\r\n      font-size: 12px;\r\n      padding: 6px 10px;\r\n      bottom: 15px;\r\n      right: 15px;\r\n    }\r\n  }\r\n  .users-tasks-page .task-times-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 4px;\r\n    margin-top: 4px;\r\n  }\r\n  \r\n  .users-tasks-page .total-time-in-status {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    font-size: 11px;\r\n    color: #666;\r\n  }\r\n  \r\n  .users-tasks-page .planned-time-remaining {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 2px;\r\n  }\r\n  \r\n  .users-tasks-page .time-row {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    font-size: 11px;\r\n  }\r\n  \r\n  .users-tasks-page .time-label {\r\n    font-weight: 600;\r\n    color: #555;\r\n  }\r\n  \r\n  .users-tasks-page .time-value {\r\n    font-weight: 500;\r\n  }\r\n  \r\n  .users-tasks-page .task-blocker {\r\n    font-size: 10px;\r\n    color: #d32f2f;\r\n    font-weight: bold;\r\n    margin-top: 4px;\r\n    padding: 1px 6px;\r\n    background-color: rgba(255, 0, 0, 0.1);\r\n    border-radius: 10px;\r\n    display: inline-block;\r\n  }\r\n\r\n  .task-status-info {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n    font-size: 11px;\r\n    color: #666;\r\n    margin-top: 2px;\r\n  }\r\n  \r\n  @media (max-width: 790px) {\r\n    .task-status-info {\r\n      font-size: 9px;\r\n      gap: 2px;\r\n    }\r\n  }\r\n  \r\n  .task-status-label {\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .task-status-time {\r\n    font-weight: 500;\r\n    color: #4299e1;\r\n  }\r\n  \r\n  /* Стилі для таймера статусу */\r\n  .status-timer {\r\n    background-color: #48bb78 !important;\r\n    color: white !important;\r\n  }\r\n  \r\n  /* Приховування кнопки PiP Mode на ширині менше 390px */\r\n  @media (max-width: 790px) {\r\n    .pip-toggle-btn {\r\n      display: none !important;\r\n    }\r\n  }\r\n  \r\n  /* Додаткові стилі для кращого відображення */\r\n  .task-card.in-progress .task-status-info,\r\n  .task-card.queued .task-status-info {\r\n    color: rgba(255, 255, 255, 0.9);\r\n  }\r\n  \r\n  .task-card.in-progress .task-status-time,\r\n  .task-card.queued .task-status-time {\r\n    color: #ffd700;\r\n  }\r\n\r\n  /* Базові стилі для світлої теми (дефолтні) */\r\n.tasks-page {\r\n    padding: 20px;\r\n    background-color: #f5f5f5;\r\n    min-height: 100vh;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n  \r\n  /* Стилі для темної теми */\r\n  .tasks-page.dark-theme {\r\n    background-color: #1a202c;\r\n  }\r\n  \r\n  .tasks-page.dark-theme .pool-section {\r\n    background-color: #414752;\r\n  }\r\n  \r\n  .tasks-page.dark-theme .pool-title-m {\r\n    color: #e2e8f0;\r\n  }\r\n  \r\n  .tasks-page.dark-theme .task-count-m {\r\n    color: #a0aec0;\r\n  }\r\n  \r\n  .tasks-page.dark-theme .no-tasks {\r\n    color: #a0aec0;\r\n  }\r\n  \r\n  .tasks-page.dark-theme .loading,\r\n  .tasks-page.dark-theme .error {\r\n    color: #e2e8f0;\r\n  }\r\n  \r\n  /* Загальні контейнери пулів залишаються незмінними */\r\n  .pool-section {\r\n    background: white;\r\n    border-radius: 12px;\r\n    padding: 20px;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n    margin-bottom: 0px;\r\n    max-width: 1200px;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n  \r\n  /* Контейнери задач залишаються незмінними */\r\n  .task-card {\r\n    position: relative;\r\n    background: #ffffff;\r\n    border: 2px solid #e2e8f0;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    transition: all 0.3s ease;\r\n  }\r\n  \r\n  /* Усі інші стилі залишаються незмінними як були */\r\n  \r\n  @media (max-width: 390px) {\r\n    .tasks-page {\r\n      padding: 10px;\r\n    }\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .pool-section {\r\n      padding: 12px;\r\n      margin-bottom: 0px;\r\n    }\r\n  }\r\n  \r\n  .pool-header {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    margin-bottom: 12px;\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .pool-header {\r\n      margin-bottom: 6px;\r\n    }\r\n  }\r\n\r\n  .pool-header-left {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n  }\r\n  .pool-title-m {\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    color: #2d3748;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    margin: 0;\r\n  }\r\n  \r\n  @media (max-width: 1000px) {\r\n    .pool-title-m {\r\n      font-size: 15px;\r\n      font-weight: 20;\r\n    }\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .pool-title-m {\r\n      font-size: 10px;\r\n    }\r\n  }\r\n  \r\n  .task-count-m {\r\n    font-size: 18px;\r\n    color: #718096;\r\n    font-weight: 500;\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .task-count-m {\r\n      font-size: 9px;\r\n    }\r\n  }\r\n  \r\n  .collapse-btn {\r\n    background-color: #4299e1;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 6px;\r\n    width: 36px;\r\n    height: 36px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n    transition: background-color 0.2s;\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .collapse-btn {\r\n      width: 28px;\r\n      height: 28px;\r\n      font-size: 14px;\r\n    }\r\n  }\r\n  \r\n  .collapse-btn:hover {\r\n    background-color: #3182ce;\r\n  }\r\n  \r\n  .tasks-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 12px;\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .tasks-list {\r\n      gap: 6px;\r\n    }\r\n  }\r\n  \r\n  .task-card.blocker {\r\n    border-color: #e53e3e;\r\n  }\r\n  \r\n  .task-card.expired {\r\n    background-color: #ffcccc;\r\n  }\r\n  \r\n  .task-card.expired .task-name {\r\n    color: #2d3748;\r\n  }\r\n  \r\n  .task-card.postponed {\r\n    background-color: #cbd5e0;\r\n  }\r\n  \r\n  .task-card.in-progress {\r\n    background-color: #2c5282;\r\n  }\r\n  \r\n  .task-card.in-progress .task-name {\r\n    color: #ffffff;\r\n  }\r\n  \r\n  .task-card.queued {\r\n    background-color: #bee3f8;\r\n  }\r\n  \r\n  .task-card.queued.expired {\r\n    background-color: #ffcccc;\r\n  }\r\n  \r\n  .task-progress {\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    transition: width 0.3s ease;\r\n    z-index: 1;\r\n  }\r\n  \r\n  .task-card.general .task-progress {\r\n    background-color: #fef9c3;\r\n  }\r\n  \r\n  .task-card.general.expired .task-progress {\r\n    background-color: #fecaca;\r\n  }\r\n  \r\n  .task-card.personal.queued .task-progress {\r\n    background-color: #4299e1;\r\n  }\r\n  \r\n  .task-card.personal .task-progress {\r\n    background-color: #e6f7ff;\r\n  }\r\n  \r\n  .task-card.personal.expired .task-progress {\r\n    background-color: transparent;\r\n  }\r\n  \r\n  .task-content {\r\n    position: relative;\r\n    z-index: 2;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 12px;\r\n    gap: 12px;\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .task-content {\r\n      padding: 6px;\r\n      gap: 6px;\r\n    }\r\n  }\r\n  \r\n  .reverse-timer-btn {\r\n    flex-shrink: 0;\r\n    width: 32px;\r\n    height: 32px;\r\n    border: none;\r\n    background-color: transparent;\r\n    color: #4a5568;\r\n    font-size: 18px;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n    transition: background-color 0.2s;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .reverse-timer-btn:hover {\r\n    background-color: rgba(0, 0, 0, 0.05);\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .reverse-timer-btn {\r\n      display: none;\r\n    }\r\n  }\r\n  \r\n  .task-timer {\r\n    flex-shrink: 0;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    color: #2d3748;\r\n    white-space: nowrap;\r\n    background-color: #ffd700;\r\n    padding: 4px 8px;\r\n    border-radius: 4px;\r\n    display: flex;\r\n    align-items: center;\r\n    height: 32px;\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .task-timer {\r\n      font-size: 10px;\r\n      padding: 2px 5px;\r\n      height: 24px;\r\n    }\r\n  }\r\n  \r\n  .task-card.blocker .task-timer {\r\n    border: 2px solid #e53e3e;\r\n  }\r\n  \r\n  .task-expired-time {\r\n    flex-shrink: 0;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    color: #c53030;\r\n    white-space: nowrap;\r\n    background-color: transparent;\r\n    padding: 4px 8px;\r\n    border-radius: 4px;\r\n    display: flex;\r\n    align-items: center;\r\n    height: 32px;\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .task-expired-time {\r\n      font-size: 10px;\r\n      padding: 2px 5px;\r\n      height: 24px;\r\n    }\r\n  }\r\n  \r\n  .task-startdate {\r\n    flex-shrink: 0;\r\n    background-color: #ff9800;\r\n    color: #c53030;\r\n    padding: 4px 8px;\r\n    border-radius: 4px;\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    display: flex;\r\n    align-items: center;\r\n    height: 32px;\r\n    white-space: nowrap;\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .task-startdate {\r\n      font-size: 9px;\r\n      padding: 2px 5px;\r\n      height: 24px;\r\n    }\r\n  }\r\n  \r\n  .task-info {\r\n    flex: 1;\r\n    min-width: 0;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 4px;\r\n  }\r\n  \r\n  .task-name {\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    color: #2d3748;\r\n    word-wrap: break-word;\r\n    line-height: 1.4;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .task-name {\r\n      font-size: 11px;\r\n      line-height: 1.3;\r\n    }\r\n  }\r\n  \r\n  .task-actions {\r\n    flex-shrink: 0;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n  }\r\n  \r\n  .task-link-btn {\r\n    width: 32px;\r\n    height: 32px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: #4299e1;\r\n    color: white;\r\n    border-radius: 4px;\r\n    text-decoration: none;\r\n    font-size: 18px;\r\n    transition: background-color 0.2s;\r\n  }\r\n  \r\n  .task-link-btn:hover {\r\n    background-color: #3182ce;\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .task-link-btn {\r\n      display: none;\r\n    }\r\n  }\r\n  \r\n  .no-tasks {\r\n    text-align: center;\r\n    padding: 40px 20px;\r\n    color: #718096;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .no-tasks {\r\n      padding: 0px 10px;\r\n      font-size: 13px;\r\n    }\r\n  }\r\n  \r\n  .loading, .error {\r\n    text-align: center;\r\n    font-size: 18px;\r\n  }\r\n  \r\n  .error {\r\n    color: #e53e3e;\r\n  }\r\n  \r\n  .pip-toggle-btn {\r\n    position: fixed;\r\n    bottom: 20px;\r\n    right: 20px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    background: white;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 6px;\r\n    padding: 8px 12px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    transition: all 0.2s ease;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .tasks-page.dark-theme .pip-toggle-btn {\r\n    background: #2d3748;\r\n    border-color: #969aa1;\r\n    color: #e2e8f0;\r\n  }\r\n  \r\n  .pip-toggle-btn:hover {\r\n    background: #f8fafc;\r\n    border-color: #cbd5e0;\r\n  }\r\n  \r\n  .tasks-page.dark-theme .pip-toggle-btn:hover {\r\n    background: #7b8391;\r\n    border-color: #718096;\r\n  }\r\n  \r\n  @media (max-width: 590px) {\r\n    .pip-toggle-btn {\r\n      font-size: 12px;\r\n      padding: 6px 10px;\r\n      bottom: 15px;\r\n      right: 15px;\r\n    }\r\n  }\r\n  .users-tasks-page .task-times-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 4px;\r\n    margin-top: 4px;\r\n  }\r\n  \r\n  .users-tasks-page .total-time-in-status {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    font-size: 11px;\r\n    color: #666;\r\n  }\r\n  \r\n  .users-tasks-page .planned-time-remaining {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 2px;\r\n  }\r\n  \r\n  .users-tasks-page .time-row {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    font-size: 11px;\r\n  }\r\n  \r\n  .users-tasks-page .time-label {\r\n    font-weight: 600;\r\n    color: #555;\r\n  }\r\n  \r\n  .users-tasks-page .time-value {\r\n    font-weight: 500;\r\n  }\r\n  \r\n  .users-tasks-page .task-blocker {\r\n    font-size: 10px;\r\n    color: #d32f2f;\r\n    font-weight: bold;\r\n    margin-top: 4px;\r\n    padding: 1px 6px;\r\n    background-color: rgba(255, 0, 0, 0.1);\r\n    border-radius: 10px;\r\n    display: inline-block;\r\n  }\r\n\r\n  .task-status-info {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n    font-size: 11px;\r\n    color: #666;\r\n    margin-top: 2px;\r\n  }\r\n  \r\n  @media (max-width: 790px) {\r\n    .task-status-info {\r\n      font-size: 9px;\r\n      gap: 2px;\r\n    }\r\n  }\r\n  \r\n  .task-status-label {\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .task-status-time {\r\n    font-weight: 500;\r\n    color: #4299e1;\r\n  }\r\n  \r\n  /* Стилі для таймера статусу */\r\n  .status-timer {\r\n    background-color: #48bb78 !important;\r\n    color: white !important;\r\n  }\r\n  \r\n  /* Приховування кнопки PiP Mode на ширині менше 390px */\r\n  @media (max-width: 790px) {\r\n    .pip-toggle-btn {\r\n      display: none !important;\r\n    }\r\n  }\r\n  \r\n  /* Додаткові стилі для кращого відображення */\r\n  .task-card.in-progress .task-status-info,\r\n  .task-card.queued .task-status-info {\r\n    color: rgba(255, 255, 255, 0.9);\r\n  }\r\n  \r\n  .task-card.in-progress .task-status-time,\r\n  .task-card.queued .task-status-time {\r\n    color: #ffd700;\r\n  }\r\n\r\n  /* Стилі для сповіщення як overlay */\r\n.notification-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 9999;\r\n    animation: fadeIn 0.3s ease;\r\n  }\r\n  \r\n  .notification-popup {\r\n    background: white;\r\n    border-radius: 12px;\r\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\r\n    width: 90%;\r\n    max-width: 400px;\r\n    animation: slideIn 0.3s ease;\r\n  }\r\n  \r\n  .tasks-page.dark-theme .notification-popup {\r\n    background: #2d3748;\r\n    border: 1px solid #4a5568;\r\n  }\r\n  \r\n  .notification-content {\r\n    padding: 24px;\r\n  }\r\n  \r\n  .notification-header {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n    margin-bottom: 16px;\r\n    position: relative;\r\n  }\r\n  \r\n  .notification-icon {\r\n    font-size: 28px;\r\n  }\r\n  \r\n  .notification-title {\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    color: #2d3748;\r\n    flex: 1;\r\n  }\r\n  \r\n  .tasks-page.dark-theme .notification-title {\r\n    color: #e2e8f0;\r\n  }\r\n  \r\n  .notification-close {\r\n    position: absolute;\r\n    top: -8px;\r\n    right: -8px;\r\n    width: 32px;\r\n    height: 32px;\r\n    border: none;\r\n    background: #e2e8f0;\r\n    color: #4a5568;\r\n    font-size: 20px;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    transition: all 0.2s;\r\n  }\r\n  \r\n  .notification-close:hover {\r\n    background: #cbd5e0;\r\n    transform: scale(1.1);\r\n  }\r\n  \r\n  .tasks-page.dark-theme .notification-close {\r\n    background: #4a5568;\r\n    color: #e2e8f0;\r\n  }\r\n  \r\n  .tasks-page.dark-theme .notification-close:hover {\r\n    background: #718096;\r\n  }\r\n  \r\n  .notification-body {\r\n    margin-bottom: 24px;\r\n  }\r\n  \r\n  .notification-body p {\r\n    margin: 8px 0;\r\n    color: #4a5568;\r\n    font-size: 16px;\r\n    line-height: 1.5;\r\n  }\r\n  \r\n  .tasks-page.dark-theme .notification-body p {\r\n    color: #cbd5e0;\r\n  }\r\n  \r\n  .notification-task-name {\r\n    font-weight: 600;\r\n    color: #2d3748 !important;\r\n    font-size: 18px !important;\r\n    padding: 12px;\r\n    background: #f7fafc;\r\n    border-radius: 8px;\r\n    border-left: 4px solid #4299e1;\r\n    word-break: break-word;\r\n  }\r\n  \r\n  .tasks-page.dark-theme .notification-task-name {\r\n    background: #4a5568;\r\n    color: #e2e8f0 !important;\r\n    border-left-color: #63b3ed;\r\n  }\r\n  \r\n  .notification-time {\r\n    color: #e53e3e !important;\r\n    font-weight: 600;\r\n    font-size: 18px !important;\r\n    text-align: center;\r\n    margin-top: 16px !important;\r\n  }\r\n  \r\n  .notification-actions {\r\n    display: flex;\r\n    gap: 12px;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .notification-btn {\r\n    padding: 12px 24px;\r\n    border: none;\r\n    border-radius: 8px;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    transition: all 0.2s;\r\n    flex: 1;\r\n    max-width: 150px;\r\n  }\r\n  \r\n  .notification-btn.ok {\r\n    background: #4299e1;\r\n    color: white;\r\n  }\r\n  \r\n  .notification-btn.ok:hover {\r\n    background: #3182ce;\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 4px 12px rgba(66, 153, 225, 0.4);\r\n  }\r\n  \r\n  .notification-btn.no-help {\r\n    background: #48bb78;\r\n    color: white;\r\n  }\r\n  \r\n  .notification-btn.no-help:hover {\r\n    background: #38a169;\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 4px 12px rgba(72, 187, 120, 0.4);\r\n  }\r\n  \r\n  .tasks-page.dark-theme .notification-btn.ok {\r\n    background: #2b6cb0;\r\n  }\r\n  \r\n  .tasks-page.dark-theme .notification-btn.ok:hover {\r\n    background: #2c5282;\r\n  }\r\n  \r\n  .tasks-page.dark-theme .notification-btn.no-help {\r\n    background: #2f855a;\r\n  }\r\n  \r\n  .tasks-page.dark-theme .notification-btn.no-help:hover {\r\n    background: #276749;\r\n  }\r\n  \r\n  /* Анімації */\r\n  @keyframes fadeIn {\r\n    from {\r\n      opacity: 0;\r\n    }\r\n    to {\r\n      opacity: 1;\r\n    }\r\n  }\r\n  \r\n  @keyframes slideIn {\r\n    from {\r\n      transform: translateY(-50px);\r\n      opacity: 0;\r\n    }\r\n    to {\r\n      transform: translateY(0);\r\n      opacity: 1;\r\n    }\r\n  }\r\n  \r\n  /* Стилі для кнопки \"Допомога не потрібна\" на картці задачі */\r\n  .no-help-btn {\r\n    flex-shrink: 0;\r\n    width: 32px;\r\n    height: 32px;\r\n    border: none;\r\n    background-color: #e2e8f0;\r\n    color: #4a5568;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n    transition: all 0.2s;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    opacity: 0.5;\r\n  }\r\n  \r\n  .no-help-btn.active {\r\n    opacity: 1;\r\n    background-color: #48bb78;\r\n    color: white;\r\n  }\r\n  \r\n  .no-help-btn.active:hover {\r\n    background-color: #38a169;\r\n    transform: scale(1.1);\r\n  }\r\n  \r\n  .no-help-btn.marked {\r\n    background-color: #48bb78;\r\n    color: white;\r\n    opacity: 1;\r\n    cursor: default;\r\n  }\r\n  \r\n  .no-help-btn:disabled {\r\n    cursor: not-allowed;\r\n  }\r\n  \r\n  .task-card.in-progress .no-help-btn.active {\r\n    background-color: #48bb78;\r\n    color: white;\r\n  }\r\n  \r\n  .task-card.in-progress .no-help-btn {\r\n    background-color: rgba(255, 255, 255, 0.2);\r\n    color: white;\r\n  }\r\n  \r\n  @media (max-width: 390px) {\r\n    .no-help-btn {\r\n      width: 24px;\r\n      height: 24px;\r\n      font-size: 12px;\r\n    }\r\n  }\r\n  \r\n  /* Стилі для кнопки \"Запитати допомогу\" */\r\n.ask-help-btn {\r\n  flex-shrink: 0;\r\n  width: 32px;\r\n  height: 32px;\r\n  border: none;\r\n  background-color: #e2e8f0;\r\n  color: #4a5568;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n  transition: all 0.2s;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.ask-help-btn:hover {\r\n  background-color: #cbd5e0;\r\n  transform: scale(1.05);\r\n}\r\n\r\n.ask-help-btn.marked {\r\n  background-color: #ed8936;\r\n  color: white;\r\n}\r\n\r\n.ask-help-btn.marked:hover {\r\n  background-color: #dd6b20;\r\n  transform: scale(1.05);\r\n}\r\n\r\n.task-card.in-progress .ask-help-btn {\r\n  background-color: rgba(255, 255, 255, 0.2);\r\n  color: white;\r\n}\r\n\r\n.task-card.in-progress .ask-help-btn:hover {\r\n  background-color: rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n.task-card.in-progress .ask-help-btn.marked {\r\n  background-color: #ed8936;\r\n  color: white;\r\n}\r\n\r\n@media (max-width: 390px) {\r\n  .ask-help-btn {\r\n    width: 24px;\r\n    height: 24px;\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n/* Стилі для пулу задач з запитом про допомогу */\r\n.ask-help-pool {\r\n  border-left: 3px solid #ed8936;\r\n}\r\n\r\n.tasks-page.dark-theme .ask-help-pool {\r\n  border-left-color: #dd6b20;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
